/** Comms guardrails v2: LLM user_message + inline blocking UI (DES-1517). */
export const IS_COMMS_GUARDRAILS_V2_ENABLED = () => {
  // FLAG_CLEANUP: hardcoded false because the PostHog flag is no longer configured.
  return false;
};
